<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/f2vY87/tc-custom/9781453274149.jpg?1728327117333" alt="This image is the cover for the book Bury My Heart at Wounded Knee"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bury My Heart at Wounded Knee
      </h1>
      <p class="bookDescription body article font2">
        <b>The “fascinating” #1 <i>New York Times</i> bestseller that awakened the world to the destruction of American Indians in the nineteenth-century West (<i>The Wall Street Journal</i>).</b><br/> First published in 1970, <i>Bury My Heart at Wounded Knee</i> generated shockwaves with its frank and heartbreaking depiction of the systematic annihilation of American Indian tribes across the western frontier. In this nonfiction account, Dee Brown focuses on the betrayals, battles, and massacres suffered by American Indians between 1860 and 1890. He tells of the many tribes and their renowned chiefs—from Geronimo to Red Cloud, Sitting Bull to Crazy Horse—who struggled to combat the destruction of their people and culture. Forcefully written and meticulously researched, <i>Bury My Heart at Wounded Knee</i> inspired a generation to take a second look at how the West was won. This ebook features an illustrated biography of Dee Brown including rare photos from the author’s personal collection.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dee Brown
      </h2>
      
      <p class="authorDescription body article">Dorris Alexander &ldquo;Dee&rdquo; Brown (1908&ndash;2002) was a celebrated author of both fiction and nonfiction, whose classic study <i>Bury My Heart at Wounded Knee </i>is widely credited with exposing the systematic destruction of American Indian tribes to a world audience. Brown was born in Louisiana and grew up in Arkansas. He worked as a reporter and a printer before enrolling at Arkansas State Teachers College, where he met his future wife, Sally Stroud. He later earned two degrees in library science, and worked as a librarian while beginning his career as a writer. He went on to research and write more than thirty books, often centered on frontier history or overlooked moments of the Civil War. Brown continued writing until his death in 2002.&#160;&#160; &#160; &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ecd7e64